declare let iNet: any;
declare let $: any;

export let AjaxAPI = {

  getUrl (url: string, domain?: string, firmPrefix?: string) {
    if(url.indexOf('://') > -1)
      return url;
    if(!domain) {
      domain = iNet.getUrl('{0}');
    }
    // @ts-ignore
    url = domain.replace('{0}', url);

    // Change firm prefix
    if (firmPrefix) {
      let urls = url.split('/');
      urls[4] = firmPrefix;
      url = urls.join('/');
    }

    return url;
  },

  // Get url by subfirm
  getPUrl (url: string, domain?: string, firmPrefix?: string) {
    return this.getUrl(url, domain, firmPrefix || iNet.firmPrefix);
  },

  // Send request
  sendRequest (options: any) {
    return $.ajax(options);
  },

  // Post ajax by FormData
  postForm (options: any) {

    options = $.extend({}, options, {
      type: 'post',
      cache: false,
      contentType: false,
      processData: false
    });

    // build form data
    if(options.data && options.data.toString().indexOf('FormData') < 0){
        let form = new FormData();
        for(let k in options.data){
          form.append(k, options.data[k]);
        }
        options.data = form;
    }

    return this.sendRequest(options);
  }

};

// Detect on mobile
// @ts-ignore
if (window['eNet']) {
  // @ts-ignore
  AjaxAPI.sendRequest = window['eNet'].ajaxSecure;
}
